export class UserConfig {
    max_studies = 3;
    max_tests_for_study = 5;
}